export function getDeviceType() {
  const ua = navigator.userAgent;

  const isTablet = /iPad|Tablet|Nexus 7|Nexus 10|SM-T|GT-P|Kindle/i.test(ua);
  const isMobile = /iPhone|Android.+Mobile|Windows Phone|BlackBerry/i.test(ua);

  if (isTablet) {
    return 'tablet';
  }

  if (isMobile) {
    return 'mobile';
  }

  return 'desktop';
}
